import React from 'react';
import { Section } from '../ui/Section';
import { Reveal } from '../ui/Reveal';
export function PainHook() {
  return <Section className="bg-white" width="narrow" data-id="element-215" data-mp="2qp7fscck38t3">
      <Reveal data-id="element-216" data-mp="2qofqtkdgs9bs">
        <p className="font-serif text-2xl italic leading-snug text-gold sm:text-[2rem]" data-id="element-217" data-mp="34hf6bmd8y3jc">
          Son las 4 de la tarde.
        </p>
      </Reveal>

      <Reveal delay={0.06} data-id="element-218" data-mp="30glieszt0oqg">
        <p className="mt-8 text-lg leading-relaxed text-body sm:text-xl" data-id="element-219" data-mp="30ifvjl4u3cjz">
          Tu cuerpo pide algo dulce con una urgencia que no se siente como antojo, se siente como
          necesidad. Buscas el café, la galleta, lo que haya en el cajón. Y a las 7 de la noche
          vuelve a pasar.
        </p>
      </Reveal>

      <Reveal delay={0.12} data-id="element-220" data-mp="2gscfpp0mx0cp">
        <p className="mt-8 text-lg leading-relaxed text-body sm:text-xl" data-id="element-221" data-mp="2gr1arlvgdmk0">
          Ya conoces todo. Sabes de porciones, de proteína, de ayuno, de comer limpio. Has probado
          en serio, con disciplina. Y aun así, cada tarde el mismo guion.
        </p>
      </Reveal>

      <Reveal delay={0.18} data-id="element-222" data-mp="3dozv4hyi373d">
        <p className="mt-10 border-l-[3px] border-gold pl-6 text-xl font-semibold leading-snug text-forest sm:text-2xl" data-id="element-223" data-mp="3dnoqyh157xbq">
          ¿Y si el problema no es lo que comes?
        </p>
      </Reveal>
    </Section>;
}